import React from 'react'

export default function SubjectLegend ({thresholdBreaks}) {
  return (
    <div id="legend">
      <ul>
        <li>
          <span className="scored-18-or-above legendCircle"></span>{`${thresholdBreaks[3]} and above`}</li>
        <li>
          <span className="scored-17 legendCircle"></span>{`Scored ${thresholdBreaks[2]}`}</li>
        <li>
          <span className="scored-16 legendCircle"></span>{`Scored ${thresholdBreaks[1]}`}</li>
        <li>
          <span className="scored-15-or-below legendCircle"></span>{`Scored ${thresholdBreaks[0]} or below`}</li>
      </ul>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Threshold/SubjectLegend.js